import { Badge } from './Elements';
import type { AnneeScolaire } from '../types';

const TONS: Record<AnneeScolaire['statut'], 'succes' | 'alerte' | 'neutre'> = {
  active: 'succes',
  preparation: 'alerte',
  cloturee: 'neutre',
};

const LIBELLES: Record<AnneeScolaire['statut'], string> = {
  active: 'active',
  preparation: 'en préparation',
  cloturee: 'clôturée',
};

/**
 * Choix de l'annee affichee par un ecran de planning.
 *
 * Le statut est rappele a cote : sans lui, une grille clouturee ressemble
 * a s'y meprendre a la grille en cours, et on la croirait modifiable.
 */
export function SelecteurAnnee({
  annees,
  anneeId,
  onChoisir,
}: {
  annees: AnneeScolaire[];
  anneeId: string;
  onChoisir: (id: string) => void;
}) {
  const annee = annees.find((a) => a.id === anneeId);

  // Une seule annee : un menu deroulant a un choix est un faux controle.
  if (annees.length <= 1) {
    return annee ? (
      <span className="flex items-center gap-2 text-sm text-encre-500">
        Année {annee.libelle}
        <Badge ton={TONS[annee.statut]}>{LIBELLES[annee.statut]}</Badge>
      </span>
    ) : null;
  }

  return (
    <label className="flex items-center gap-2 text-sm text-encre-500">
      Année
      <select
        className="champ w-auto py-1.5"
        value={anneeId}
        onChange={(evenement) => onChoisir(evenement.target.value)}
      >
        {annees.map((candidate) => (
          <option key={candidate.id} value={candidate.id}>
            {candidate.libelle}
          </option>
        ))}
      </select>
      {annee && <Badge ton={TONS[annee.statut]}>{LIBELLES[annee.statut]}</Badge>}
    </label>
  );
}

/**
 * Bandeau de lecture seule sur une annee clouturee. Explique pourquoi les
 * boutons ont disparu, plutot que de les laisser echouer.
 */
export function BandeauAnneeFigee({ annee }: { annee: AnneeScolaire }) {
  return (
    <div className="carte mb-4 border-encre-200 bg-encre-50 p-4 text-sm text-encre-600">
      <strong className="font-medium text-encre-800">Année {annee.libelle} clôturée.</strong> La
      grille est figée (RG-27) : elle reste consultable et imprimable, mais ne peut plus être
      modifiée. Pour préparer la rentrée, créez l’année suivante puis reprenez cette grille.
    </div>
  );
}
